import React from "react";
import { Layout, Row, Col, Card, Button } from "antd";
import "./ProductCreationProcess.scss";

const product_creation_tools = [
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/tool-01-dashboard.png",
        title: "User dashboard",
        desc: 'Manage your workflow seamlessly, keeping everything organized in one place. Track key metrics at a glance, including models in progress, images rendered, and  messages from your team.'

    },
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/tool-02-collaboration.png",
        title: "Collaboration tools",
        desc: 'Streamline communication with your team to finalize images effortlessly using our image markup tool. Easily leave comments, track feedback in threaded discussions, and receive notifications to stay updated.'
    },
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/tool-03-assets.png",
        title: "Asset manager",
        desc: 'Easily manage all your 3D assets in one place with our image library. Mark your favorites or use filters to quickly find images to collaborate on, download, and more.',
    },
    {
        img: "https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/tool-04-cloud.png",
        title: "Cloud services",
        desc: 'Access, store, and share all your 3D models and assets securely with our cloud storage. Your libraries are always up-to-date across projects and teams.',
    }
];

const ToolsInfoMobile = () => {

    return (
        <Row className="justify-in-center product-tool-creation-wrapper-mobile">
            <div className="show-mobile-tools">
                <h1 className="manrope f-30 lh-40 w-600 black-085 mb-16 text-left">Plus, tools that make your workflow seamless</h1>
                <p className="manrope f-16 lh-24 w-500 black-085 mb-40 text-left">
                    Our end-to-end workflow keeps projects on track and organized for the whole team.
                </p>
                <Row className="justify-space-between direction-flex roww">
                    {product_creation_tools.map((tool, index) => (
                        <Col span={24}>
                            <div className={`image-with-background bg-${index}`}>
                                <img src={tool.img} className="tool-img" />
                            </div>
                            <div className="tool-container">
                                <h3 className="manrope f-20 w-700 lh-28 black-085 mb-8">{tool.title}</h3>
                                <p className="manrope f-14 lh-22 w-500 black-085 mb-0">{tool.desc}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Button onClick={() => {
                        window.location.href = '/pricing'
                    }}
                        className={`w-100 manrope f-16 w-700 lh-24 white-button-black-border mt-40`}>
                        View pricing & plans
                    </Button>
                </Row>
            </div>
        </Row>
    );
};

export default ToolsInfoMobile;
